var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-col',{attrs:{"cols":"3","sm":"1"}},[_c('v-avatar',{staticClass:"text-end",staticStyle:{"filter":"drop-shadow(0px 2px 2px rgba(0,0,0,0.6))"},attrs:{"id":"profile-image","size":_vm.iconSize}},[_c('v-img',{attrs:{"src":_vm.userProfile},on:{"error":_vm.updateProfileSafe}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }